import {
  createFrontendModule,
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { waadooIcons } from '../ui/icons/waadooIcons';
import { PROJECT_ENTITY_FILTER } from '../shared';
import { COSTS_PATH, costsRouteRef } from './routeRef';
import { projectCostsFrTranslation } from './translation';

const CostsIcon = waadooIcons.costs;

// What makes an entity a project: the filter of every project card
// (`projectEnvironments/plugin.tsx`), `PROJECT_ENTITY_FILTER`; the card then
// reads the project with `projectIdOf`.
const projectFilter = PROJECT_ENTITY_FILTER;

// « Coûts » (CostsCard.tsx), under « Promotion »: named right after it in
// `app.extensions` (app-config). Renders nothing where the `waadoo-costs`
// backend plugin has no routes (its 404).
const projectCostsEntityCard = EntityCardBlueprint.make({
  name: 'project-costs',
  params: {
    type: 'content',
    filter: projectFilter,
    loader: async () => {
      const { CostsCard } = await import('./CostsCard');
      return <CostsCard />;
    },
  },
});

/**
 * The card, on the `catalog` plugin, which owns the entity page it attaches
 * to. Registered in packages/app/src/App.tsx.
 */
export const projectCostsModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [projectCostsEntityCard],
});

/**
 * « Coûts plateforme » (CostsPage.tsx), for the admin tier. A title and an
 * icon so that the app's nav lists it; the sidebar takes it explicitly,
 * after « Tâches », for admins only (`page:waadoo-costs` in
 * modules/nav/Sidebar.tsx). The title is French as it stands, like the
 * « Tâches » page's.
 *
 * `noHeader`: the page paints its own header, with its description.
 */
const costsPage = PageBlueprint.make({
  params: {
    path: COSTS_PATH,
    title: 'Coûts',
    icon: <CostsIcon size="1em" aria-hidden focusable="false" />,
    routeRef: costsRouteRef,
    noHeader: true,
    loader: async () => {
      const { CostsPage } = await import('./CostsPage');
      return <CostsPage />;
    },
  },
});

/** Registered in packages/app/src/App.tsx. */
export const costsPagePlugin = createFrontendPlugin({
  pluginId: 'waadoo-costs',
  extensions: [costsPage],
});

/**
 * The French messages, on the `app` plugin: a TranslationBlueprint under any
 * other pluginId is ignored without a word (see `projectEnvironments/plugin.tsx`).
 */
export const projectCostsTranslationModule = createFrontendModule({
  pluginId: 'app',
  extensions: [projectCostsFrTranslation],
});
